import { DateTime } from 'luxon';
import { useState } from 'react';
import { Calendar, CalendarModalAlignment } from '..';
import cc from 'classcat';

interface IDatePicker {
    enablePastDays?: boolean;
    label?: string;
    onSelected: (date: DateTime) => void;
    id: string;
    selectedDate?: DateTime;
    isError?: boolean;
    errorMessage?: string;
    hideDate?: boolean;
    weekSelect?: boolean;
    modalAlignment?: CalendarModalAlignment;
}

const DatePicker = ({
    label,
    onSelected,
    selectedDate,
    isError,
    errorMessage,
    enablePastDays,
    hideDate,
    weekSelect,
    modalAlignment = 'right',
}: IDatePicker) => {
    const [displayDate, setDisplayDate] = useState(DateTime.now().startOf('day'));
    const [displayCalendar, setDisplayCalendar] = useState(false);

    const changeDate = (selectedDate: DateTime) => {
        if (enablePastDays || selectedDate >= DateTime.now().startOf('day')) {
            onSelected(selectedDate);
        }
    };

    return (
        <div className="date-range-picker">
            {label && <label className="input__label">{label}</label>}
            <button
                type="button"
                className={cc([
                    'date-range-picker__button',
                    { 'date-range-picker__button--error': isError && errorMessage, 'date-range-picker__button--opened': displayCalendar },
                ])}
                onClick={() => setDisplayCalendar(prev => !prev)}
            >
                {!hideDate && selectedDate && `${selectedDate?.toFormat('MMM dd')}`}
                <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M3.5 8.08338C3.5 5.87424 5.29086 4.08337 7.5 4.08337H20.5C22.7091 4.08337 24.5 5.87423 24.5 8.08337V21.6667C24.5 23.8758 22.7091 25.6667 20.5 25.6667H7.5C5.29086 25.6667 3.5 23.8758 3.5 21.6667V8.08338Z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                    />
                    <path d="M3.5 10.5H24.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M9.33301 2.33337L9.33301 5.83337" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M18.667 2.33337V5.83337" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <ellipse cx="13.9997" cy="17.5" rx="1.16667" ry="1.16667" fill="currentColor" />
                    <ellipse cx="18.6667" cy="17.5" rx="1.16667" ry="1.16667" fill="currentColor" />
                    <ellipse cx="9.33366" cy="17.5" rx="1.16667" ry="1.16667" fill="currentColor" />
                </svg>
            </button>
            {isError && errorMessage && <p className="input__error-message">{errorMessage}</p>}
            {displayCalendar && (
                <>
                    <div className="event-bubbling-mask" onClick={() => setDisplayCalendar(false)}></div>
                    <Calendar
                        enablePastDays={enablePastDays}
                        displayDate={displayDate}
                        changeMonth={setDisplayDate}
                        onClick={changeDate}
                        activeModal
                        startDate={weekSelect ? selectedDate?.startOf('week') : undefined}
                        endDate={weekSelect ? selectedDate?.endOf('week') : undefined}
                        singleDate={!weekSelect ? selectedDate : undefined}
                        modalAlignment={modalAlignment}
                    />
                </>
            )}
        </div>
    );
};

export default DatePicker;
